module.exports = __webpack_public_path__ + "static/media/P.d2896592.png";